import React from 'react';

import { token } from '@atlaskit/tokens';

export const RovoLogo = (): React.JSX.Element => (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M13.4352 0.363775C12.6088 -0.112663 11.592 -0.121106 10.7588 0.338447C10.7437 0.350143 10.7258 0.362058 10.7088 0.371866C10.1158 0.714353 9.68229 1.26299 9.47849 1.89674C9.39559 2.15859 9.35178 2.43521 9.35178 2.71837V6.31195L12.7406 8.26623L13.8592 8.91009C14.9656 9.54587 15.6439 10.7211 15.6439 11.9956V21.2728C15.6439 21.6482 15.5845 22.0155 15.4723 22.3631C15.4603 22.4007 15.4477 22.4381 15.4344 22.4753L21.4779 18.9885C22.3219 18.5036 22.8395 17.6076 22.8395 16.6342V7.35705C22.8395 6.38749 22.3187 5.48749 21.4773 5.00239L19.9351 4.11389L13.4352 0.363775Z"
			fill={token('elevation.surface')}
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M2.66999 18.9977L4.10278 19.8244L10.7097 23.6363C11.5361 24.1126 12.553 24.1211 13.3861 23.6616C13.4012 23.6499 13.4173 23.6391 13.4343 23.6293C14.0279 23.287 14.462 22.7382 14.6662 22.1042C14.7492 21.8421 14.7931 21.5651 14.7931 21.2817V17.6881L11.2961 15.6713L10.2885 15.0902C9.18226 14.4544 8.50344 13.2789 8.50344 12.0045V2.7274C8.50344 2.35249 8.56274 1.9857 8.67462 1.63854C8.68676 1.60041 8.69954 1.56253 8.71294 1.5249L2.66944 5.01169C1.82552 5.49653 1.30786 6.39257 1.30786 7.36597V16.6431C1.30786 17.6127 1.82857 18.5126 2.66999 18.9977Z"
			fill={token('elevation.surface')}
		/>
	</svg>
);
